
import { Component, Vue, Prop } from 'vue-property-decorator'
import { UserModule } from '../../store/modules/user'
import PanelHeader from './PanelHeader.vue'
import DashboardTeacherCourse from './DashboardTeacherCourse.vue'
import { getCookie, setCookie, mul, getMonth } from '../../utils/publish'
import echarts from 'echarts'
  @Component({ 
    name: 'DashboardOrder',
    components: { PanelHeader, DashboardTeacherCourse } 
  })
  
export default class DashboardTeacher extends Vue {
    tableData: any= []
    type = 0
    title = ''
    tableHeight: number = window.innerHeight - 200
    tableWidth: number = window.innerWidth - 270
    list:any = []
    instrumentTypes:any = []
    teacherType:any = []
    campusType:any = []
    time:any = [new Date(<any>new Date() - 1000 * 60 * 60 * 24 * 30),new Date()]
    start_time = ''
    end_time = ''
    groupData = [
      {
        title: 'employee_name',
        label: '人员',
        width: '150',
        flag: true
      },
      {
        title: 'baohe_ratio',
        label: '教师时间饱和率',
        width: '120',
        flag: true
      },
      {
        title: 'fuhe_ratio',
        label: '正式课负荷率',
        width: '120',
        flag: true
      },
      {
        title: 'danwei_ratio',
        label: '单位产出比',
        width: '100',
        flag: true
      },
      {
        title: 'remen_ratio',
        label: '热门率',
        width: '100',
        flag: true
      },
      {
        title: 'tiaoshi_ratio',
        label: '跳失率',
        width: '100',
        flag: true
      },
      {
        title: 'peoplenum_dabiao_ratio',
        label: '教学人数达标率',
        width: '120',
        flag: true
      },
      {
        title: 'mubiao_ratio',
        label: '教学目标达标率',
        width: '120',
        flag: true
      },
      {
        title: 'jieke_ratio',
        label: '学员结课率',
        width: '100',
        flag: true
      },
      {
        title: 'course_time',
        label: '发布课程时长',
        width: '100',
        flag: false
      },
      {
        title: 'work_time',
        label: '教师工作时长',
        width: '100',
        flag: false
      },
      {
        title: 'sign_time',
        label: '消耗学生课时',
        width: '100',
        flag: false
      },
      {
        title: 'sign_count',
        label: '消耗学生课次',
        width: '100',
        flag: false
      },
      {
        title: 'sign_student_count',
        label: '学员上课人数',
        width: '100',
        flag: false
      },
      {
        title: 'student_level',
        label: '学员等级分布',
        width: '100',
        flag: false
      },
      {
        title: 'level_peoplenum',
        label: '完成各等级人数',
        width: '120',
        flag: false
      },
      // {
      //   title: 'level_course_time',
      //   label: '完成各等级课时',
      //   width: '120',
      //   flag: false
      // },
    ]
    tabPosition: any = ''
    employee_id: any = ''
    ages: any = []
    source: any = []
    loading: boolean = false
    lineShow: boolean = false
    showTeacher: boolean = false
    courseType: number = 0
    isCourse: boolean = false
    positionType: boolean = false
    isGetTime: boolean = false
    showSource: boolean = true
    months = [
        {
          flag: false,
          id: '01'
        },
        {
          flag: false,
          id: '02'
        },
        {
          flag: false,
          id: '03'
        },
        {
          flag: false,
          id: '04'
        },
        {
          flag: false,
          id: '05'
        },
        {
          flag: false,
          id: '06'
        },
        {
          flag: false,
          id: '07'
        },
        {
          flag: false,
          id: '08'
        },
        {
          flag: false,
          id: '09'
        },
        {
          flag: false,
          id: '10'
        },
        {
          flag: false,
          id: '11'
        },
        {
          flag: false,
          id: '12'
        }
      ]

    getHeight() {
      window.onresize = () =>{
        this.tableHeight = window.innerHeight - 200
      }
    }
    getSelectChange(val: any) {
      if(!this.tabPosition) {
        this.tabPosition = this.$route.query.property
      }
      this.employee_id = this.$route.query.employee_id
      this.getCookieData()
      if (this.employee_id) { // 有老师
        this.getTeachList('')
      } else {  // 全部
        this.getTeachList(1)
      }
      this.handleClick(this.tabPosition)
      this.isGetTime = false
    }
    getCourseList() {
      this.isCourse = false
    }
    handleClick(val) {
      this.tabPosition = val
      if (this.tabPosition.indexOf('_ratio') >= 0) {
        this.positionType = true
      } else {
        this.positionType = false
      }
      for (var i = 0; i < this.months.length; i++) {
        this.months[i].flag = false
      }
      this.yearTeachList()
      if (this.tabPosition === 'course_time') {
        this.courseType = 1
        this.isCourse = true
      } else if (this.tabPosition === 'work_time') {
        this.courseType = 2
        this.isCourse = true
      } else if (this.tabPosition === 'sign_time') {
        this.courseType = 4
        this.isCourse = true
      } else if (this.tabPosition === 'sign_count') {
        this.courseType = 8
        this.isCourse = true
      } else if (this.tabPosition === 'sign_student_count') {
        this.courseType = 5
        this.isCourse = true
      } else if (this.tabPosition === 'student_level') {
        this.courseType = 3
        this.isCourse = true
      } else if (this.tabPosition === 'level_peoplenum') {
        this.courseType = 6
        this.isCourse = true
      } else if (this.tabPosition === 'level_course_time') {
        this.courseType = 7
        this.isCourse = true
      } else {
        this.courseType = 0
        this.isCourse = true
      }
    }

    getMul(val1, val2) {
      return mul(val1, val2)
    }

    getNowMonth(type, months, year, month) {
      return getMonth(type, months, year, month)
    }
    getGoodTime(time, type) {
      const t = Date.parse(<any> new Date(time))
      let day: any = ''
      if (type === 1) { // 开始时间
        day = t - 8 * 60 * 60 * 1000
      } else if (type === 2) { // 结束时间
        day = t + 16 * 60 * 60 * 1000 - 1000
      }
      return new Date(day)
    }
    
    drawLine(yearList, dataList){
      const that = this
      // 基于准备好的dom，初始化echarts实例
      let dom:any = document.getElementById('myChart')
      let myChart:any = echarts.init(dom)
      myChart.on('click', function (params) {
        const day = params.name
        if (!day) {
          return false
        }
        const year = day.split('/')[0]
        let month: any = day.split('/')[1]
        let start:any = that.getNowMonth('s', 0, year, month)
        let end:any = that.getNowMonth('e', 0, year, month)
        start = that.getGoodTime(start, 1)
        end = that.getGoodTime(end, 2)
        const time = [start, end]
        setCookie('time', JSON.stringify(time), 1)
        that.isGetTime = true
      })
      // 绘制图表
      myChart.setOption({
        title: {
          text: '',
          textStyle:{
            color:'#333',
          }
        },
        color: ['#3398DB'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: yearList,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '',
            type: 'bar',
            barWidth: '50%',
            data: dataList,
            itemStyle: {
							normal: {
								label: {
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#333'
									}
								}
							}
						},
          }
        ]
      });
    }

    drawLine1(yearList, dataList){
      const that = this
      // 基于准备好的dom，初始化echarts实例
      let dom:any = document.getElementById('myChart1')
      let myChart:any = echarts.init(dom)
      myChart.on('click', function (params) {
        const day = params.name
        if (!day) {
          return false
        }
        const year = day.split('/')[0]
        const month = day.split('/')[1]
        let start:any = that.getNowMonth('s', 0, year, month)
        let end:any = that.getNowMonth('e', 0, year, month)
        start = that.getGoodTime(start, 1)
        end = that.getGoodTime(end, 2)
        const time = [start, end]
        setCookie('time', JSON.stringify(time), 1)
        that.isGetTime = true
      })
      // 绘制图表
      myChart.setOption({
        title: {
          text: '',
          textStyle:{
            color:'#333',
          }
        },
        color: ['#3398DB'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter:'{c}%'　　　　//这是关键，在需要的地方加上就行了
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: yearList,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '',
            type: 'bar',
            barWidth: '50%',
            data: dataList,
            itemStyle: {
							normal: {
								label: {
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#333'
                  },
                  formatter: '{c}%'　　　　//这是关键，在需要的地方加上就行了
								}
							}
						},
          }
        ]
      });
    }
    
    async yearTeachList() {
      const res = await UserModule.yearTeachData({ field_name: this.tabPosition, instrument_type: this.instrumentTypes.toString(), campus_id: this.campusType.toString(), teacher_id: this.employee_id, start_time: this.start_time, end_time: this.end_time, ages: this.ages.toString(), source: this.source.toString()})
      if(res.data.length === 0) {
        this.lineShow = false
        return false
      }
      this.lineShow = true
      let year = ''
      if(res.data[0].months) {
        year = res.data[0].months.substring(0, 4)
      } else {
        year = ''
      }
      const yearData = res.data
      for (var m = 0; m < this.months.length; m++) {
        this.months[m]['flag'] = false
      }
      for (var i = 0; i < this.months.length; i++) {
        for(var j = 0; j < res.data.length; j++) {
          if(res.data[j].months) {
            const str = res.data[j].months
            if (this.months[i].id === str.substring(str.length - 2)) {
              this.months[i].flag = true
            }
          }
        }
      }
      let obj = {}
      obj[this.tabPosition] = 0
      for (var k = 0; k < this.months.length; k++) {
        if (!this.months[k].flag) {
          yearData.splice(k, 0, obj);
        }
      }
      const yearList = []
      const dataList = []
      for (var i = 0; i < this.months.length; i++) {
        yearList.push(year + '/' + this.months[i].id)
        let it = yearData[i][this.tabPosition]
        if(!it) {
          it = 0
        }
        if (this.positionType) {
          dataList.push(this.getMul(it, 100))
        } else {
          dataList.push(it)
        }
      }
      if (this.positionType) {
        this.drawLine1(yearList, dataList)
      } else {
        this.drawLine(yearList, dataList)
      }
    }

    async getTeachList(val) {
      const res = await UserModule.teachList({ is_total: val, data_type: 1, instrument_type: this.instrumentTypes.toString(), campus_id: this.campusType.toString(), teacher_id: this.employee_id, start_time: this.start_time, end_time: this.end_time, ages: this.ages.toString(), source: this.source.toString()})
      this.tableData = res.data
      if (this.tableData.length > 0) {
        this.loading = true
      } else {
        this.loading = false
      }
    }

    getCookieData() {
      this.instrumentTypes = JSON.parse(getCookie('instrumentTypes'))
      this.teacherType = JSON.parse(getCookie('teacherType'))
      this.campusType = JSON.parse(getCookie('campusType'))
      this.source = JSON.parse(getCookie('source')) 
      this.ages = JSON.parse(getCookie('ages'))
      this.time = JSON.parse(getCookie('time'))
      this.start_time = (Date.parse(<any>this.time[0])/1000).toString()
      this.end_time = (Date.parse(<any>this.time[1])/1000).toString()
    }

    mounted() {
      this.tabPosition = this.$route.query.property
      this.employee_id = this.$route.query.employee_id
      if (this.tabPosition.indexOf('_ratio') >= 0) {
        this.positionType = true
      } else {
        this.positionType = false
      }
      this.getCookieData()
      this.getHeight()
      if (this.employee_id) { // 有老师
        this.getTeachList('')
      } else {  // 全部
        this.getTeachList(1)
      }
      this.yearTeachList()
    }
  }
